import { siteConfig } from '../config/site';

/** API host for landing form — REACT_APP_API_URL only in local dev. */
export function getApiBaseUrl() {
  return process.env.REACT_APP_API_URL || siteConfig.urls.api;
}
